import { signOut } from "@app/auth";
import { config } from "@app/config";
import { IS_SERVER_CONTEXT, setApiContext } from "@ea/api_client/api/apiContext";
import "@ea/ui/styles";
import { getClientAuth } from "./clientAuth";

function initContext() {
  setApiContext({
    baseUrl: config.getApiPath(),
    getAuthToken: async () => {
      const session = getClientAuth();
      return session?.data?.authToken;
    },
    signOut,
  });
}

export function initClientContext() {
  if (!IS_SERVER_CONTEXT) {
    initContext();
  }
}
